/* esm.sh - rxjs@7.8.2/dist/esm/internal/observable/of */
import{popScheduler as e}from"rxjs/dist/esm/internal/util/args";import{from as t}from"rxjs/dist/esm/internal/observable/from";function p(...o){let r=e(o);return t(o,r)}export{p as of};
//# sourceMappingURL=of.mjs.map